<div class="message">
    <div class="time">{{todaysTime}}</div>
    <div class="date">{{todaysDate}}</div>
    <div class="summary">
        <p>"invenire" - (Latin) v. “to find, discover, or come across”</p>
        <p>Invenire is a secure portal which hosts metadata from backup and data archive environments</p>
        <p><a href="https://www.sullivanstrickler.com/" target="_blank">Learn more</a></p>
    </div>
</div>